import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import { AnonymousStudentServiceReady } from '../../../anonymous-student-interfaces/events';
import { AnonymousStudentService } from '../application/anonymous-student-service';
import { StudentRepository } from '../domain/student-repository';

export class AnonymousStudentInitializer  {
	public initialize(): void {
		// The standalone AnonymousStudent bundle may still be loaded next to StudentJS during the migration
		if (window['AnonymousStudent']) {
			return;
		}

		this.initializeStudentRepository();
	}
	private initializeStudentRepository(): void {
		const studentRepository = new StudentRepository(this.eventAggregationService);
		const anonymousStudent = new AnonymousStudentService(studentRepository);
		window['AnonymousStudent'] = anonymousStudent;
		studentRepository.initialize();
		const anonymousStudentServiceReadyEvent = new AnonymousStudentServiceReady(anonymousStudent);
		this.eventAggregationService.publishTo(AnonymousStudentServiceReady.EventType, anonymousStudentServiceReadyEvent);
	}

	private get eventAggregationService(): IEventAggregationService  {
		//eslint-disable-next-line @typescript-eslint/no-unsafe-return
		return window['EventAggregationService'];
	}
}